import { UserProfileImage } from "@moim/common";
import * as React from "react";
// components
import { Wrapper, ProfileContainer, ProfileImageHolder } from "./styled";

// hooks

interface IProps {
  type: "show" | "preview";
  userId: Moim.Id;
  avatar: string;
  isOnline: boolean;
  onCloseRequest?(): void;
}

const ProfileHeader: React.FC<IProps> = ({
  type,
  userId,
  avatar,
  isOnline,
}) => {
  const avatarSize: Moim.DesignSystem.Size = React.useMemo(
    () => (type === "show" ? "xl" : "l"),
    [type],
  );
  const containerBottomPadSize = React.useMemo(
    () => (type === "show" ? 32 : 16),
    [type],
  );

  const handleClickAvatar = React.useCallback(() => {}, []);

  return (
    <Wrapper>
      <ProfileContainer bottomSpace={containerBottomPadSize}>
        <ProfileImageHolder type={type} onClick={handleClickAvatar}>
          <UserProfileImage
            size={avatarSize}
            shape="round"
            src={avatar}
            userId={userId}
            isOnline={isOnline}
          />
        </ProfileImageHolder>
      </ProfileContainer>
    </Wrapper>
  );
};

export default ProfileHeader;
